
    // this file was auto generated by python script
    import Loader from './Loader';
    export default Loader;
    